import { Directive, Inject, InjectionToken } from '@angular/core';
import { TemplateLayoutHelper } from '@fi-app/template/template-layout-helper';
import { BaseItemModelService } from '@fi-app/template/base-item.model';

export const FI_DOCUMENT_TEMPLATE_ITEM_VIEW_DATA = new InjectionToken<IFiDocumentTemplateItemViewData>(
    'FI_DOCUMENT_TEMPLATE_ITEM_VIEW_DATA',
);

export interface IFiDocumentTemplateItemViewData {
    item: BaseItemModelService;
    disableEdit: boolean;
    templateLayoutHelper: TemplateLayoutHelper;
}

@Directive()
export abstract class FiDocumentTemplateItemViewBase {
    constructor(@Inject(FI_DOCUMENT_TEMPLATE_ITEM_VIEW_DATA) public data: IFiDocumentTemplateItemViewData) {}
}
